export type RouteConfig = {
    label: string;
    value: string;
};

export const routesConfig: RouteConfig[] = [
    { label: "Access Requests > List", value: "/access-requests/list" },
    { label: "Analytics", value: "/analytics" },
    {
        label: "App Content > Farmer Feed",
        value: "/app-content/hub?tab=feeds",
    },
    {
        label: "App Content > Notification Manager",
        value: "/app-content/hub?tab=notifications",
    },
    {
        label: "App Content > Rewards",
        value: "/app-content/hub?tab=rewards",
    },
    {
        label: "App Content > Surveys/Feedback Forms",
        value: "/app-content/hub?tab=forms",
    },
    {
        label: "App Content > Registrations",
        value: "/app-content/registrations",
    },
    { label: "Approvals > List", value: "/approvals/list" },
    { label: "Buyer Orders > List", value: "/buyer-orders/list" },
    { label: "Buyer Orders > New", value: "/buyer-orders/new" },
    { label: "Cluster Management > List", value: "/cluster-management/list" },
    { label: "Collection Center", value: "/collection-center" },
    {
        label: "Content Management > All Farmer Feed",
        value: "/content-management/all-farmer-feed",
    },
    {
        label: "Content Management > All Rewards",
        value: "/content-management/all-rewards",
    },
    {
        label: "Content Management > Farmer Feed",
        value: "/content-management/farmer-feed",
    },
    { label: "Content Management", value: "/content-management" },
    {
        label: "Content Management > Public Feeds",
        value: "/content-management/public-feeds",
    },
    {
        label: "Content Management > Registrations",
        value: "/content-management/registrations",
    },
    { label: "Cp Commissions > List", value: "/cp-commissions/list" },
    { label: "Cp Commissions > New", value: "/cp-commissions/new" },
    { label: "Data Upload", value: "/data-upload" },
    {
        label: "Equipment Rental > Booking Location",
        value: "/equipment-rental/booking-location",
    },
    {
        label: "Equipment Rental > Booking Schedule",
        value: "/equipment-rental/booking-schedule",
    },
    {
        label: "Equipment Rental > Booking Scheduler",
        value: "/equipment-rental/scheduler",
    },
    { label: "Field Tracking", value: "/field-tracking" },
    { label: "Index", value: "/index" },
    { label: "Insurance", value: "/insurance" },
    { label: "Insurance > Providers", value: "/insurance/providers" },
    { label: "Inventory > List", value: "/inventory/list" },
    { label: "Login", value: "/login" },
    { label: "Market Insights > List", value: "/market-insights/list" },
    { label: "Pnl > Finances", value: "/pnl/finances" },
    { label: "Pnl > Reconciliation", value: "/pnl/reconciliation" },
    { label: "Poc > List", value: "/poc/list" },
    { label: "Procurement > List", value: "/procurement/list" },
    { label: "Procurement > New", value: "/procurement/new" },
    {
        label: "Produces And Categories > Configure Parameters",
        value: "/produces-and-categories/configure-parameters",
    },
    {
        label: "Produces And Categories > Hub > Categories",
        value: "/produces-and-categories/hub?tab=categories",
    },
    {
        label: "Produces And Categories > Hub > Produce Types",
        value: "/produces-and-categories/hub?tab=produce-types",
    },
    {
        label: "Produces And Categories > Hub > Produce Parameters",
        value: "/produces-and-categories/hub?tab=produce-parameters",
    },
    {
        label: "Produces And Categories > New Produce",
        value: "/produces-and-categories/new-produce",
    },
    {
        label: "Rewards > Feature Availability",
        value: "/rewards/feature-availability",
    },
    { label: "Rewards > New Rewards", value: "/rewards/new-rewards" },
    { label: "Rewards > Redemptions", value: "/rewards/redemptions" },
    { label: "Rewards > Reward Details", value: "/rewards/reward-details" },
    { label: "Rewards > Reward Tiers", value: "/rewards/reward-tiers" },
    { label: "Seller Orders > List", value: "/seller-orders/list" },
    { label: "Soil Testing > Tests", value: "/soil-testing/tests" },
    { label: "Shipments > Confirm", value: "/shipments/confirm" },
    { label: "Shipments > Import", value: "/shipments/import" },
    { label: "Shipments > List", value: "/shipments/list" },
    { label: "Shipments > New", value: "/shipments/new" },
    { label: "Surveys > Submissions", value: "/surveys/submissions" },
    { label: "Surveys > User Submissions", value: "/surveys/user-submissions" },
    { label: "Transactions", value: "/transactions" },
    { label: "Translations", value: "/translations" },
    { label: "Users", value: "/users" },
];
